
import '../../css/main.css'
import './style.css'
import Menu from '../../common/menu.js';
import TopBar from "../../common/topBar";
import { useEffect, useState } from 'react';
import CreateInterestRates from './create-interest-rates.js'
import CreateLatePaymentInterest from './create-late-payment-interest.js'
import DeleteDialog1 from './delete-dialog-1.js'
import DeleteDialog2 from './delete-dialog-1.js'
import BaiscTable from '../../tables/default-table.js';
import { useAuth } from '../../../contexts/AuthContext.js';
import { useLocation, useNavigate } from 'react-router-dom';
import { useData } from '../../../contexts/DataContext.js';
import DefaultLayout from '../../layouts/DefaultLayout.js';
import toast from 'react-hot-toast';
import Loader from '../../loaders/loader.jsx';

export default function Create() {

const [createInterestRates, setCreateInterestRates] = useState(false);
const [createPaymentInterest, setCreatePaymentInterest] = useState(false);

const [settings,setSettings]=useState([])
const [loading,setLoading]=useState(false)
const [edit1, setEdit1] = useState(null);
const [del1, setDel1] = useState(null);
const [edit2, setEdit2] = useState(null);
const [del2, setDel2] = useState(null);

const {pathname} = useLocation()
const {user,selectedMicrocredit,userInfo,userRole,setUser} = useAuth()
const [form,setForm]=useState({})
const data=useData()
const navigate=useNavigate()

let required_data=['interest_rates','late_payment_interests']
const [updateFilters,setUpdateFilters]=useState(null)

useEffect(()=>{ 
   if(!user) return
   data.handleLoaded('remove',required_data)
   data._get(required_data,{
      interest_rates:{microcredit_id:selectedMicrocredit},
      late_payment_interests:{microcredit_id:selectedMicrocredit}
   }) 
 },[user,pathname,updateFilters])


 useEffect(()=>{
   data.handleLoaded('remove',required_data,)
 },[updateFilters])

 useEffect(()=>{
   if(data.updateTable){
        data.setUpdateTable(null)
        data.handleLoaded('remove',required_data)
        data._get(required_data,{
            interest_rates:{microcredit_id:selectedMicrocredit},
            late_payment_interests:{microcredit_id:selectedMicrocredit}
        }) 
   }
},[data.updateTable])



useEffect(()=>{
    if((userRole=="operator" && !userInfo?.permissions?.contract_settings?.includes('create'))){
        navigate('/dashboard')
    }
},[userInfo]) 





 async function updateMicro(){ 

  toast.remove()

  setLoading(true)
 
  try{
     await data.makeRequest({method:'post',url:`api/microcredit/profile/update/contract-settings/${form.id}`,withToken:true,data:{
          ...form
     }, error: ``},0);

     toast.remove()
     toast.success("Actualizado com sucesso")
     setLoading(false)

    setUser({
      ...user,
      microcredits: user.microcredits.map((i) => {
      if (i.id == selectedMicrocredit) {
            return {
            ...i,
            interest_calculation_method: form.interest_calculation_method,
            stamp_duty: form.stamp_duty,
            preparation_fee: form.preparation_fee,
            insurance_fee: form.insurance_fee
            };
      } else {
            return i;
      }
      })
  });


  }catch(e){
     toast.remove()

     let msg="Acorreu um erro, tente novamente"

     setLoading(false)

     if(e.response){
      
       if(e.response.status==404){
           msg="Item não encontrado"
       }
       if(e.response.status==500){
           msg="Erro, inesperado. Contacte seu administrador"
       }

     }else if(e.code=='ERR_NETWORK'){
           msg="Verfique sua internet e tente novamente"
     }

     toast.error(msg)

  }
}


    useEffect(()=>{
     if(!user) return
   
     if(user?.role!="admin"){
         setForm(user.microcredits.filter(i=>i.id==selectedMicrocredit)[0] || {})
     }
   
   },[user,userRole])

   console.log({form})



return (
    <>
      <DefaultLayout>
      <main className="dashboard-container">

      {<CreateInterestRates showD={(createInterestRates || edit1) ? true : false}  create={createInterestRates} setCreate={setCreateInterestRates} setEdit={setEdit1} edit={edit1} del={del1}/>}
      {<CreateLatePaymentInterest showD={(createPaymentInterest || edit2) ? true : false}  create={createPaymentInterest} setCreate={setCreatePaymentInterest} setEdit={setEdit2} edit={edit2} del={del2}/>}

      {<DeleteDialog1 showD={del1 ? true : false} del={del1}  setDel={setDel1}/>}
      {<DeleteDialog2 showD={del2 ? true : false} del={del2}  setDel={setDel2}/>}

      <div className="dashboard">
      <Menu/>
      <div className="main-dashboard">
            <TopBar activePage={'Definições de contrato'} lastPage={{name:'Contratos',pathname:'/loans'}}/>
            <div className="center">
                  <div className="loan-container">
                             
                              <div className="top-title">Definições de juros</div>
                              <div className="section">
                                    <div className="sub-title">Taxas de juros {(userRole!="operator" || userInfo?.permissions?.contracts_settings?.includes('create')) && <button onClick={()=>setCreateInterestRates(true)}>Adicionar taxa</button>}</div>
                                    <div className="_table max-w-[700px]">

                                    <BaiscTable canAdd={user?.role=="admin"}  loaded={data._loaded.includes('interest_rates')} header={[
                                          <BaiscTable.MainActions  sigleSelection={true} data={data} options={{
                                          deleteFunction:'default',
                                          deleteUrl:'api/interest-rates/delete'}
                                          } items={data._interest_rates || []}/>,
                                             'Duração',
                                             'Percentagem (%)',
                                             'Contratos associados'
                                         ]
                                    }
                                    body={(data._interest_rates || []).map((i,_i)=>(
                                                <BaiscTable.Tr disabled={i.contracts.length}>
                                                <BaiscTable.Td w={30}>
                                                      <BaiscTable.Actions  hide={true} sigleSelection={true}  data={data}  options={{
                                                            deleteFunction:'default',
                                                            deleteUrl:'api/interest-rates/delete',
                                                            id:i.id}
                                                      }/>
                                                </BaiscTable.Td>
                                                <BaiscTable.Td onClick={()=>setEdit1(i)}>{i.duration_type=="days" ? i.days : i.months} {i.duration_type=="days" ? `${i.days == 1 ? 'dia':'dias'}`: `${i.months == 1 ? 'mês':'meses'}`}</BaiscTable.Td>
                                                <BaiscTable.Td onClick={()=>setEdit1(i)}>{i.percentage}</BaiscTable.Td>
                                                <BaiscTable.Td onClick={()=>setEdit2(i)}>{i.contracts.length || '-'}</BaiscTable.Td>
                                          </BaiscTable.Tr>
                                          ))}
                                    />


                                 </div>
                              </div>







                              <div className="section">
                                    <div className="sub-title">Taxas de juros de mora {(userRole!="operator" || userInfo?.permissions?.contracts_settings?.includes('create')) && <button onClick={()=>setCreatePaymentInterest(true)}>Adicionar taxa</button>}</div>
                                    <div className="_table max-w-[700px]">
                                    <BaiscTable canAdd={user?.role=="admin"} addRes={()=>{
                                          
                                    }}  loaded={data._loaded.includes('late_payment_interests')} header={[
                                          <BaiscTable.MainActions  sigleSelection={true} data={data} options={{
                                          deleteFunction:'default',
                                          deleteUrl:'api/late-payment-interests/delete'}
                                          } items={data._late_payment_interests || []}/>,
                                          'De',
                                          'Até',
                                          'Percentagem (%)',
                                          'Contratos associados'
                                          ]
                                    }

                                    body={(data._late_payment_interests || []).map((i,_i)=>(
                                          
                                                <BaiscTable.Tr disabled={i.Contracts.length}>
                                                <BaiscTable.Td w={30}>
                                                      <BaiscTable.Actions hide={true}  sigleSelection={true}  data={data}  options={{
                                                            deleteFunction:'default',
                                                            deleteUrl:'api/late-payment-interests/delete',
                                                            id:i.id}
                                                      }/>
                                                </BaiscTable.Td>
                                                <BaiscTable.Td onClick={()=>setEdit2(i)}>{i.from}</BaiscTable.Td>
                                                <BaiscTable.Td onClick={()=>setEdit2(i)}>{i.to}</BaiscTable.Td>
                                                <BaiscTable.Td onClick={()=>setEdit2(i)}>{i.percentage}</BaiscTable.Td>
                                                <BaiscTable.Td onClick={()=>setEdit2(i)}>{i.Contracts.length || '-'}</BaiscTable.Td>
                                                
                                          </BaiscTable.Tr>
                                          ))}
                                    />
                                 </div>

                              </div>

                              <div className="px-5 py-5">
                                    <div class="mb-5">
                                          <label class="block mb-2 text-sm font-medium text-gray-900">Tipo de Cálculo de Juros</label>
                                          <select disabled={!(userRole=="manager" || userInfo?.permissions?.contract_settings?.includes('update'))} value={form.interest_calculation_method} onChange={(e)=>{
                                                 setForm({...form,interest_calculation_method:e.target.value})
                                          }} class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg  block p-2.5">
                                                <option value="simple">Cálculo Simples</option>
                                                <option value="price">Fórmula Tabela Price (Sistema Francês)</option>
                                          </select>
                                    </div>
                                    <div class="mb-5">
                                          <label class="block mb-2 text-sm font-medium text-gray-900">
                                          Percentagem de taxa de imposto de selo
                                          </label>
                                          <input
                                          disabled={!(userRole == "manager" || userInfo?.permissions?.contract_settings?.includes('update'))}
                                          placeholder="(%)"
                                          onWheel={(e) => e.target.blur()}
                                          value={form.stamp_duty}
                                          onChange={(e) => setForm({ ...form, stamp_duty: e.target.value })}
                                          type="number"
                                          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block p-2.5"
                                          required
                                          />
                                          </div>

                                          <div class="mb-5">
                                          <label class="block mb-2 text-sm font-medium text-gray-900">
                                          Percentagem de taxa de custo de preparo
                                          </label>
                                          <input
                                          disabled={!(userRole == "manager" || userInfo?.permissions?.contract_settings?.includes('update'))}
                                          placeholder="(%)"
                                          onWheel={(e) => e.target.blur()}
                                          value={form.preparation_fee}
                                          onChange={(e) => setForm({ ...form, preparation_fee: e.target.value })}
                                          type="number"
                                          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block p-2.5"
                                          required
                                          />
                                          </div>

                                          <div class="mb-5">
                                          <label class="block mb-2 text-sm font-medium text-gray-900">
                                          Percentagem de taxa de seguro
                                          </label>
                                          <input
                                          disabled={!(userRole == "manager" || userInfo?.permissions?.contract_settings?.includes('update'))}
                                          placeholder="(%)"
                                          onWheel={(e) => e.target.blur()}
                                          value={form.insurance_fee}
                                          onChange={(e) => setForm({ ...form, insurance_fee: e.target.value })}
                                          type="number"
                                          class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg block p-2.5"
                                          required
                                          />
                                    </div>



                                    {(
                                          user.microcredits.filter(i => i.id == selectedMicrocredit)?.[0]?.interest_calculation_method != form.interest_calculation_method ||
                                          user.microcredits.filter(i => i.id == selectedMicrocredit)?.[0]?.stamp_duty != form.stamp_duty ||
                                          user.microcredits.filter(i => i.id == selectedMicrocredit)?.[0]?.preparation_fee != form.preparation_fee ||
                                          user.microcredits.filter(i => i.id == selectedMicrocredit)?.[0]?.insurance_fee != form.insurance_fee
                                          ) && (
                                          <div className="flex items-center">
                                          {loading && (
                                                <div className="mt-1">
                                                <Loader />
                                                </div>
                                          )}
                                          {!loading && (
                                                <button
                                                onClick={() => {
                                                updateMicro();
                                                }}
                                                id="confirm-button"
                                                type="button"
                                                className="mt-2 py-2 px-4 w-full text-sm font-medium text-center rounded-[0.3rem] text-white bg-custom_blue-400 sm:w-auto bg-honolulu_blue-500 hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300"
                                                >
                                                salvar
                                                </button>
                                          )}
                                          </div>
                                    )}
                              </div>
                  </div>
            </div>
      </div>
      </div>
      </main>
      </DefaultLayout>
    </>
  );
}
